import { Stylist } from "../../../../features/Stylisation";
import { StylistPage } from "../../../../pages/StylistPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const stylizationPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.stylizator.root,
  element: <StylistPage />,
  name: "Стилизатор",
  children: appRouterPaths.stylizator.item
    ? [
        {
          path: appRouterPaths.stylizator.item,
          element: <Stylist />,
          name: "Объекты стилизатора",
        },
      ]
    : undefined,
};
